/**
 * Emballage cadeau AYA (voir snippets/aya-gift-wrap.liquid).
 * - Case cochée : ajoute le produit Emballage cadeau au panier. Décochée : le retire.
 * - Petit mot : enregistré sur la ligne Emballage cadeau (propriété « Petit mot »).
 * Script classique : les écouteurs sont posés sur le document car le panier latéral est redessiné à chaque mise à jour.
 */
(function () {
  'use strict';

  var PROPERTY = 'Petit mot';
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var queue = Promise.resolve();
  var inflight = 0;
  var dirty = false;
  var toggling = false;
  var typingTimer;

  function getBox(el) {
    if (el && el.closest) {
      var box = el.closest('[data-aya-gift]');
      if (box) return box;
    }
    return document.querySelector('[data-aya-gift]');
  }

  function sectionsFor(box) {
    var drawer = box && box.closest ? box.closest('cart-drawer') : null;
    if (!drawer || !drawer.dataset.sectionId) return null;
    return [drawer.dataset.sectionId, 'auto-gifts'].join(',');
  }

  function post(path, payload) {
    return fetch(base + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.json().then(function (json) {
        if (!response.ok) throw json;
        return json;
      });
    });
  }

  function enqueue(task) {
    inflight++;
    queue = queue.then(task, task).then(
      function (value) {
        inflight--;
        return value;
      },
      function () {
        inflight--;
      },
    );
    return queue;
  }

  function showError() {
    document.dispatchEvent(
      new CustomEvent('toast:open', { detail: { type: 'error', message: "Oups, l'emballage cadeau n'a pas pu être mis à jour. Merci de réessayer." } }),
    );
  }

  // Redessine le panier latéral avec la réponse de Shopify (même événement que le reste du thème)
  function refresh(hasSections, data) {
    if (!hasSections || !data || !data.sections) {
      window.location.reload();
      return;
    }

    var event = new Event('cart:updated', { bubbles: true });
    event.detail = {
      resource: {},
      data: {
        source: 'cart-note',
        sections: data.sections,
        itemCount: typeof data.item_count === 'number' ? data.item_count : undefined,
      },
    };
    document.dispatchEvent(event);
  }

  function toggleGift(input) {
    var box = getBox(input);
    if (!box) return;

    if (toggling) {
      input.checked = !input.checked;
      return;
    }

    toggling = true;
    box.classList.add('is-loading');

    var variantId = box.dataset.variantId;
    var sections = sectionsFor(box);
    var path;
    var payload;

    if (input.checked) {
      path = 'cart/add.js';
      payload = { items: [{ id: Number(variantId), quantity: 1 }] };
    } else {
      path = 'cart/update.js';
      payload = { updates: {} };
      payload.updates[variantId] = 0;
      dirty = false;
      clearTimeout(typingTimer);
    }

    if (sections) {
      payload.sections = sections;
      payload.sections_url = window.location.pathname;
    }

    enqueue(function () {
      return post(path, payload)
        .then(function (data) {
          refresh(!!sections, data);
        })
        .catch(function () {
          input.checked = !input.checked;
          showError();
        })
        .then(function () {
          toggling = false;
          box.classList.remove('is-loading');
        });
    });
  }

  function saveMessage(redraw) {
    return enqueue(function () {
      var box = getBox();
      var area = box ? box.querySelector('[data-aya-gift-message]') : null;
      if (!box || !area || !box.dataset.lineKey) return null;

      dirty = false;

      var max = Number(box.dataset.maxChars) || 150;
      var properties = {};
      properties[PROPERTY] = area.value.trim().slice(0, max);

      var sections = redraw ? sectionsFor(box) : null;
      var payload = { id: box.dataset.lineKey, quantity: Number(box.dataset.quantity) || 1, properties: properties };

      if (sections) {
        payload.sections = sections;
        payload.sections_url = window.location.pathname;
      }

      return post('cart/change.js', payload)
        .then(function (data) {
          // Modifier le mot change l'identifiant de la ligne : on garde le nouveau
          var items = (data && data.items) || [];
          for (var i = 0; i < items.length; i++) {
            if (String(items[i].variant_id) === String(box.dataset.variantId)) {
              box.dataset.lineKey = items[i].key;
              break;
            }
          }

          if (redraw && sections) refresh(true, data);
        })
        .catch(function () {
          dirty = true;
          showError();
        });
    });
  }

  // Case à cocher
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!target || !target.matches) return;

    if (target.matches('[data-aya-gift-toggle]')) {
      toggleGift(target);
      return;
    }

    // Sortie du champ : on enregistre et on affiche le mot sur la ligne du panier
    if (target.matches('[data-aya-gift-message]')) {
      clearTimeout(typingTimer);
      if (dirty) saveMessage(true);
    }
  });

  // Pendant la saisie : enregistrement discret, sans redessiner le panier
  document.addEventListener('input', function (event) {
    var target = event.target;
    if (!target || !target.matches || !target.matches('[data-aya-gift-message]')) return;

    dirty = true;
    clearTimeout(typingTimer);
    typingTimer = setTimeout(function () {
      if (dirty) saveMessage(false);
    }, 1200);
  });

  // Clic sur « Commander » alors que le mot n'est pas encore enregistré : on enregistre d'abord, puis on part au paiement
  document.addEventListener(
    'click',
    function (event) {
      var button = event.target && event.target.closest ? event.target.closest('[data-ref="checkout-button"], button[name="checkout"]') : null;
      if (!button) return;
      if (!dirty && inflight === 0) return;

      event.preventDefault();
      event.stopPropagation();
      clearTimeout(typingTimer);
      button.classList.add('is-loading');

      var done = function () {
        window.location.href = base + 'checkout';
      };

      (dirty ? saveMessage(false) : queue).then(done, done);
    },
    true,
  );
})();
